export default "__VITE_ASSET__0528dbcb__"